import * as PIXI from 'pixi.js';

import { Point } from '../models';
import { environment } from '../../../../environments/environment';
import { GlowFilter } from '@pixi/filter-glow';
import { CardData } from '../../../shared/models';
import { AnchorPosition } from './const';
import { GameComponent } from '../game.component';

// import { Store } from '@ngrx/store';
import { GameService } from '../game.service';
import { NgZone } from '@angular/core';

import * as CONST from './cards-cotrollers/player-cards-controller-const'
import { AssetsLoaderService } from '../../../core/services/assets-loader.service';
import { ConfigService } from '../../../core/services/config.service';

enum AnimationDirectionType {
    FADE_IN = 0,
    FADE_OUT = 1,
    PAUSE = 2,
}

export class AnimationText {

    public container: PIXI.Container;
    private textInfo: PIXI.Text;
    private textInfoStyle: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: ['Arial', 'Helvetica', 'sans-serif'],
        fontSize: 40,
        fontWeight: 'bold',
        fontStyle: 'italic',
        fill: ['#FFFFFF', '#D9D9D9'],
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowAlpha: 0.8,
        dropShadowAngle: Math.PI / 2,
        dropShadowDistance: 2,
        dropShadowBlur: 2,
        padding: 6,
    });

    private textHandStrength: PIXI.Text;
    private textHandStrengthStyle: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: ['Arial', 'Helvetica', 'sans-serif'],
        fontSize: 40,
        fontWeight: 'bold',
        fontStyle: 'italic',
        fill: ['#FFE45C', '#D6A93A'],
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowAlpha: 0.8,
        dropShadowAngle: Math.PI / 2,
        dropShadowDistance: 2,
        dropShadowBlur: 2,
        padding: 6,
    });

    private background: PIXI.Graphics | PIXI.Sprite;
    private backgroundColor = 0x000000;
    private backgroundAlpha = 0.9;

    private BAND_HEIGHT = 56;
    private BAND_MAX_ALPHA = 0.5;
    private BAND_FADE_WIDTH_RATIO = 0.5;
    private BAND_SLICES = 48;
    private TEXT_GAP = 0;

    private PADDING_TOP = 10;
    private PADDING_LEFT = 25
    private ANIMATION_SPEED = 120

    private positionX = 1920
    private portraitMode = false;

    private animationDirection: AnimationDirectionType = AnimationDirectionType.PAUSE;
    private pauseTimeStart: number;
    private pauseTimeAllowed = 5000 * 10// 5 SEC
    private fadeTimeStart: number;
    private fadeTimeTotal: number;

    private animationConfigSetTime: number;
    private POSITION_TOP_PORTRAIT = 305
    private POSITION_TOP_DESKTOP = 280
    private POSITION_TOP = 0
    config;
    constructor(
        public assetsLoader: AssetsLoaderService,
        private configService: ConfigService,
    ) {
        this.config = this.configService.config;

        this.container = new PIXI.Container();
        this.container.position.set(this.positionX, this.POSITION_TOP);


        this.background = new PIXI.Graphics();
        this.background.beginFill(this.backgroundColor, this.backgroundAlpha);
        this.background.drawRect(0, 0, 0, 0);
        this.background.endFill();

        this.container.addChild(this.background);
        this.container.alpha = 0
  
        //manual start:
        // this.setConfig('Smurf won the pot', 'dsaddasdsadsadsa', 24000, false)
        // setTimeout(() => {
        //     this.setConfig('Smurf won the pot', '', 141000, false)

        // }, (3000));
    }

    setPortraitMode(portraitMode: boolean) {
        this.portraitMode = portraitMode;
    }

    setConfig(textInfo: string, textHandStrength: string, pauseTimeAllowed: number, portraitMode: boolean) {

        this.container.removeChild(this.textInfo)
        this.textInfo = new PIXI.Text(textInfo, this.textInfoStyle);
        this.textInfo.position.set(0, this.getTextTop(this.textInfo));
        this.container.addChild(this.textInfo);

        this.container.removeChild(this.textHandStrength)
        this.textHandStrength = null


        if (textHandStrength) {
            if (this.config.brand !== '111') {
                (this.background as PIXI.Graphics).clear();
            } else {
                (this.background as PIXI.Sprite).alpha = 0;

            }
            this.textHandStrength = new PIXI.Text(textHandStrength, this.textHandStrengthStyle);

            this.textHandStrength.position.set(this.textInfo.width + this.TEXT_GAP, this.getTextTop(this.textHandStrength));
            this.container.addChild(this.textHandStrength);
            this.container.alpha = 1    
        }
        this.pauseTimeAllowed = pauseTimeAllowed;
        this.animationDirection = AnimationDirectionType.FADE_IN;

        this.portraitMode = portraitMode
        this.refreshBackgroud()
        this.POSITION_TOP = this.portraitMode ? this.POSITION_TOP_PORTRAIT : this.POSITION_TOP_DESKTOP;
        this.positionX = this.portraitMode ? 1080 : 1920;
        this.container.position.set(this.positionX, this.POSITION_TOP);
        this.fadeTimeStart = null;
        this.fadeTimeTotal = null;
        this.pauseTimeStart = null;
        this.animationConfigSetTime = new Date().getTime();
    }



    resetAnimation() {
        this.container.position.set(this.container.width * -1, this.POSITION_TOP);
        this.animationDirection = AnimationDirectionType.FADE_OUT
        this.animationConfigSetTime = 0
    }

    update(dt) {
        // dt ~15ms
        let width = 0;
        if (this.textInfo && this.textHandStrength) {
            width = (this.textInfo.width + this.textHandStrength.width) / 2;
        } else if (this.textInfo) {
            width = this.textInfo.width / 2;
        }

        if (new Date().getTime() - this.animationConfigSetTime >= this.pauseTimeAllowed + 500) { // 500ms SAFE delay
            this.resetAnimation()
            return
        }

        if (this.animationDirection === AnimationDirectionType.FADE_IN) { // ## FADE IN - move to center

            if (!this.fadeTimeStart) {
                this.fadeTimeStart = new Date().getTime()
            }

            if (this.positionX > (((this.portraitMode ? 1080 : 1920) / 2) - width) + this.ANIMATION_SPEED) {
                this.positionX -= this.ANIMATION_SPEED
                this.container.position.set(this.positionX, this.POSITION_TOP);
            } else if (this.positionX > (((this.portraitMode ? 1080 : 1920) / 2) - width)) {
                this.positionX = (((this.portraitMode ? 1080 : 1920) / 2) - width) //this.positionX - (((this.portraitMode ? 1080 : 1920) / 2) - width)
                this.container.position.set(this.positionX, this.POSITION_TOP);
            } else {
                this.fadeTimeTotal = new Date().getTime() - this.fadeTimeStart;
                this.fadeTimeStart = null;

                this.pauseTimeStart = new Date().getTime();
                this.animationDirection = AnimationDirectionType.PAUSE
            }
        } else if (this.animationDirection === AnimationDirectionType.FADE_OUT) { // ## FADE OUT - move out

            if (this.positionX > (-1 * this.container.width)) {
                this.positionX -= this.ANIMATION_SPEED
                this.container.position.set(this.positionX, this.POSITION_TOP);
            }
        } else if (this.animationDirection === AnimationDirectionType.PAUSE) { // ## PAUSE
            if (new Date().getTime() - this.pauseTimeStart >= this.pauseTimeAllowed - (this.fadeTimeTotal * 2)) {
                this.animationDirection = AnimationDirectionType.FADE_OUT
            }
        }

        if (this.config.brand === '111') {
            this.refreshBackgroud()
        }
    }

    private getTextTop(text: PIXI.Text): number {
        if (this.config.brand === '111') {
            return this.PADDING_TOP;
        }
        return (this.BAND_HEIGHT - text.height) / 2;
    }

    private drawBand() {
        const screenWidth = this.portraitMode ? 1080 : 1920;
        let halfTextWidth = 0;
        if (this.textInfo && this.textHandStrength) {
            halfTextWidth = (this.textInfo.width + this.textHandStrength.width) / 2;
        } else if (this.textInfo) {
            halfTextWidth = this.textInfo.width / 2;
        }
        const bandLeft = halfTextWidth - screenWidth / 2;
        const sliceWidth = screenWidth / this.BAND_SLICES;
        const graphics = this.background as PIXI.Graphics;

        graphics.clear();
        for (let i = 0; i < this.BAND_SLICES; i++) {
            const center = (i + 0.5) / this.BAND_SLICES;
            const edgeDistance = Math.min(center, 1 - center) / this.BAND_FADE_WIDTH_RATIO;
            const t = Math.min(1, edgeDistance);
            const smooth = t * t * (3 - 2 * t);
            const alpha = this.BAND_MAX_ALPHA * smooth * smooth;
            graphics.beginFill(this.backgroundColor, alpha);
            graphics.drawRect(bandLeft + i * sliceWidth, 0, Math.ceil(sliceWidth), this.BAND_HEIGHT);
            graphics.endFill();
        }
    }

    private refreshBackgroud() {
        if (this.config.brand !== '111') {
            this.drawBand();
        } else {
            let backgroundPositionX = 0
            if (this.textInfo && this.textHandStrength) {
                backgroundPositionX = -(this.background.width - (this.textInfo.width + this.textHandStrength.width)) / 2;
            } else if (this.textInfo) {
                backgroundPositionX = -(this.background.width - (this.textInfo.width)) / 2;
            }
            (this.background as PIXI.Sprite).alpha = 1;
            (this.background as PIXI.Sprite).position.x = backgroundPositionX
            //(this.background as PIXI.Sprite).tint = 0x000000;
        }

    }

}
